import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
    GoogleMap,
    Marker,
    useJsApiLoader,
    Circle,
} from '@react-google-maps/api';
import { googleMapsProps } from '../../constants';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import {BarLoader} from 'react-spinners';
import { getSepcialPageFieldKeysForDataabse } from 'src/helpers/pages';
import BraynFilterBar from './BraynFilterBar';
import {BottomSheet, BottomSheetRef} from 'react-spring-bottom-sheet';
import { PropagateLoader } from 'react-spinners';

import 'react-spring-bottom-sheet/dist/style.css';
import { IDatabaseField } from 'src/services/database';
import BraynTemplateModal from '../pages/BraynTemplateModal';

const center = {
    lat: 30.4515,
    lng: -91.1871,
};

export default function BraynResults({
    database,
    results,
    intl,
    term,
    setTerm,
    pageId,
    setLocation,
    currentLocation,
    setSelectedFilters,
    selectedLocation,
    selectedFilters,
    setDistance,
    distance,
    onSearch,
    onClearFilters,
    loading,
    renderPager,
    totalRowCount,
    setType,
    type,
    onKeyDown,
    currentDistance,
    searchInput,
    setSearchInput,
}) {
    const sheetRef = React.useRef<BottomSheetRef>();
    const [open, setOpen] = useState<boolean>(false);
    const [currentlyViewingPage, setCurrentlyViewingPage] = useState<string | null>(null);
    const mapCenter = currentLocation || center;

    const [hoveredResult, setHoveredResult] = useState(null);

    useLayoutEffect(() => {
        document?.getElementById?.('searchAddressBar')?.parentElement?.classList?.add?.('col');
    });

    useEffect(() => {
        setCurrentlyViewingPage(pageId)
    }, [pageId])

    const { isLoaded } = useJsApiLoader(googleMapsProps as any);

    const {
        title: titleKey,
        description: descKey,
        map: mapKey,
    }: any = database ? getSepcialPageFieldKeysForDataabse(database) : {};

    const handlePageClose = () => {
        if (currentlyViewingPage === pageId) onSearch(searchInput, 1, undefined, undefined, true)
        setCurrentlyViewingPage(null)
    }

    const renderSearchResultWrapper = (content: any) => {
        if (type === 'grid')
            return (
                <div className="col-lg-4 col-sm-12 col-md-6">
                    <div className="liveviewCon">{content}</div>
                </div>
            );
        return content;
    };

    const renderAttribute = (value: string, icon: any) => (
        <div style={{display: 'flex', alignItems: 'start'}}>
            {icon}
            <span className="text-muted ml-2" style={{fontSize: 14}}>
                {value}
            </span>
        </div>
    );

    const renderAttributes = (item: any) => {
        const {
            number: num,
            contact,
            contactFirst,
            contactLast,
            email,
            agesServed,
            fees,
        } = getSepcialPageFieldKeysForDataabse(database) as any;

        return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                {item[contact] &&
                    renderAttribute(
                        JSON.parse(item[contact]),
                        <em className="fas fa-user text-muted pt-1" style={{fontSize: 12}} />
                    )}
                {item[num] &&
                    renderAttribute(
                        JSON.parse(item[num]),
                        <em className="fas fa-phone text-muted pt-1" style={{fontSize: 12}} />
                    )}
                {item[email] &&
                    renderAttribute(
                        JSON.parse(item[email]),
                        <em className="fas fa-envelope text-muted pt-1" style={{fontSize: 12}} />
                    )}
                {item[agesServed] &&
                    renderAttribute(
                        Array.isArray(JSON.parse(item[agesServed]))
                            ? sortList(JSON.parse(item[agesServed]), database?.fields?.find(f => f.name === 'ages_served')).join(', ')
                            : JSON.parse(item[agesServed]),
                        <em className="fas fa-child text-muted pt-1" style={{fontSize: 12}} />
                    )}
                {item[fees] &&
                    renderAttribute(
                        JSON.parse(item[fees]),
                        <em className="fas fa-dollar-sign text-muted pt-1" style={{fontSize: 12}} />
                    )}
            </div>
        );
    };

    const renderSearchResult = (item: any, i: number) => {
        try {
            if (!database) return;

            const title = item[titleKey] && JSON.parse(item[titleKey]);
            const desciption = item[descKey] && JSON.parse(item[descKey]);

            const image = item.account_organization_avatar;
            let bgImage = {};
            if (image !== '(none)') {
                bgImage = {
                    backgroundImage: `url("${image.replace(/ /g, '%20')}")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: '300px 168.75px',
                };
            }
            return renderSearchResultWrapper(
                <a
                    key={item.name}
                    style={{
                        textDecoration: 'none',
                        color: 'black',
                        cursor: 'pointer',
                    }}
                    className="row py-2 px-4 px-lg-3"
                    data-toggle="modal"
                    data-target={`#detailModal`}
                    onClick={() => setCurrentlyViewingPage(item.name)}
                    onMouseEnter={() => setHoveredResult(item.name)}>
                    <div className="d-flex w-100">
                        {image !== '(none)' && (
                            <div
                                className="col border-top border-bottom border-left rounded-left px-1 image"
                                style={{
                                    ...bgImage,
                                    overflow: 'hidden',
                                    backgroundSize: 'contain',
                                    maxWidth: 150,
                                }}>
                                {image ? (
                                    <span />
                                ) : (
                                    <div className="mx-auto">
                                        <BarLoader height={4} width={300} />
                                    </div>
                                )}
                            </div>
                        )}
                        <div
                            className="col border rounded-right p-lg-3 p-2"
                            style={hoveredResult === item.name ? styles.boxShadow : {}}>
                            <div className="flex-direction-row">
                                <h4>{title}</h4>
                                <h5 style={{color: '#595959'}}>
                                    {item?.account_organization_name}
                                </h5>
                            </div>
                            <div className="p">{renderAttributes(item)}</div>
                        </div>
                    </div>
                </a>
            );
        } catch (ex) {}
        return null;
    };

    const renderResultCount = () => {
        if (!results?.length)
            return (
                <div className="text-center">
                    <h3>No Results Found</h3>
                </div>
            );
        return (
            <div>
                <h2 className="text-muted ml-4">
                    {totalRowCount} Result{totalRowCount !== 1 ? 's' : ''} Found
                </h2>
            </div>
        );
    };

    const sortList = (list: string[], databaseField: IDatabaseField) => {
        return list.sort((a, b) => Array.isArray(databaseField.options) ? databaseField.options.indexOf(a) - databaseField.options.indexOf(b) : 0);
    }

    return (
        <>
            {currentlyViewingPage ? <BraynTemplateModal pageId={currentlyViewingPage} database={database} onClose={handlePageClose} /> : null}
            <div style={{height: 65, width: '100%', boxShadow: '0 0 3px 0 rgba(0,0,0,.1)'}}>
                <BraynFilterBar
                    database={database}
                    intl={intl}
                    term={searchInput}
                    setTerm={setSearchInput}
                    setLocation={setLocation}
                    location={selectedLocation || currentLocation}
                    filter={selectedFilters}
                    setDistance={setDistance}
                    distance={distance}
                    setFilter={setSelectedFilters}
                    onSearch={() => onSearch(searchInput, 1)}
                    onClearFilters={onClearFilters}
                    type={type}
                    setType={setType}
                    onKeyDown={onKeyDown}
                />
            </div>
            <div className="flex-fill d-flex">
                <div
                    className={`col-${type === 'map' ? 4 : 12} d-${
                        type === 'map' ? 'none' : 'block'
                    } d-lg-block`}
                    style={{
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        maxHeight: window.innerHeight - 87.5 - 75,
                        minWidth: type === 'map' ? 450 : undefined,
                    }}
                    onMouseLeave={() => setHoveredResult(null)}>
                    {results.map(renderSearchResult)}
                    {loading ? (
                        <div className="p-5 d-flex justify-content-center">
                            <PropagateLoader size={15} loading={loading} color="#29447b" />
                        </div>
                    ) : (
                        !results?.length && (
                            <div className="text-center mt-4">
                                <h3>No Results Found</h3>
                                <div>Try changing your filters!</div>
                            </div>
                        )
                    )}
                    <div className="searchfltercontent">{renderPager()}</div>
                </div>
                {type === 'map' && isLoaded && (
                    <GoogleMap
                        mapContainerClassName="flex-fill"
                        center={mapCenter}
                        zoom={Math.floor(
                            Math.log2(
                                (40000 / currentDistance) *
                                    Math.cos((mapCenter?.lat * Math.PI) / 180)
                            )
                        )}
                        options={{
                            minZoom: 10,
                            streetViewControl: false,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                        }}>
                        {Array.isArray(results) &&
                            mapKey &&
                            results?.map?.((r) => {
                                try {
                                    const data = JSON.parse(r[mapKey]);
                                    if (
                                        data?.coordinates?.latitude &&
                                        data?.coordinates?.longitude
                                    ) {
                                        return (
                                            <Marker
                                                key={`marker-${r.name}`}
                                                position={{
                                                    lat: data?.coordinates?.latitude,
                                                    lng: data?.coordinates?.longitude,
                                                }}
                                                icon={{
                                                    path: faMapMarker.icon[4] as string,
                                                    fillColor:
                                                        hoveredResult === r.name
                                                            ? 'red'
                                                            : '#29447b',
                                                    fillOpacity: 1,
                                                    anchor: new google.maps.Point(14, 30),
                                                    strokeWeight: 1,
                                                    strokeColor: '#ffffff',
                                                    scale: hoveredResult === r.name ? 0.1 : 0.075,
                                                }}
                                                clickable
                                                label={
                                                    hoveredResult === r.name
                                                        ? {
                                                              text: JSON.parse(r[titleKey]),
                                                              className:
                                                                  'bg-dark text-light p-2 rounded',
                                                          }
                                                        : undefined
                                                }
                                                onClick={() => setCurrentlyViewingPage(r.name)}
                                                onMouseOver={() => setHoveredResult(r.name)}
                                                onMouseOut={() => setHoveredResult(null)}
                                            />
                                        );
                                    }
                                } catch (ex) {
                                    console.error(ex);
                                }
                                return null;
                            })}
                        {mapCenter && (
                            <Circle
                                center={mapCenter}
                                radius={currentDistance * 1609.34} // miles to meters
                                options={{
                                    strokeWeight: 0,
                                    fillColor: '#0080FF',
                                    fillOpacity: 0.35,
                                    clickable: false,
                                    draggable: false,
                                    editable: false,
                                    visible: true,
                                    zIndex: 1,
                                }}
                            />
                        )}
                    </GoogleMap>
                )}
            </div>
            {type === 'map' && (
                <BottomSheet
                    className="d-lg-none"
                    open={true}
                    ref={sheetRef as any}
                    onDismiss={() => {
                        sheetRef?.current?.snapTo(({snapPoints}) => 200, {velocity: 1});
                        setOpen(false);
                    }}
                    snapPoints={({maxHeight, headerHeight}) => [headerHeight, maxHeight * 0.9]}
                    scrollLocking={open}
                    blocking={open}
                    expandOnContentDrag
                    onSpringEnd={() => {
                        if ((sheetRef?.current?.height || 0) > 200) {
                            setOpen(true);
                        } else if ((sheetRef?.current?.height || 0) < 100) {
                            setOpen(false);
                        }
                    }}
                    header={renderResultCount()}>
                    {results.map(renderSearchResult)}
                    {(
                        !results?.length && (
                            <div className="text-center mt-4">
                                <div>Try changing your filters!</div>
                            </div>
                        )
                    )}
                    <div className="searchfltercontent">{renderPager()}</div>
                </BottomSheet>
            )}
        </>
    );
}

const styles = {
    boxShadow: {
        backgroundColor: '#f5f5f5',
    },
};



// WEBPACK FOOTER //
// ./src/public/search/BraynResults.tsx